import { jsx as _jsx } from "react/jsx-runtime";
import { Txt } from "../../components/Txt/Txt";
import styles from "./OrderAttributesInfo.module.scss";
export const OrderAttributesInfo = ({ orderAttributesInfos }) => {
    if (orderAttributesInfos.length === 0) {
        return null;
    }
    return (_jsx("div", { className: styles.orderAttributes, children: orderAttributesInfos.map((attribute) => (_jsx(Txt, { variant: "txt-1", className: styles.orderAttributesText, children: attribute.value }, attribute.attribute_code))) }));
};
//# sourceMappingURL=OrderAttributesInfo.js.map